"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountSaga = exports.getSelfServiceAccounts = exports.deleteAccountDeactivation = exports.getDeactivationAccounts = exports.createAccountDeactivations = exports.updateAccountPayoutSettings = exports.updateAccount = exports.createAccount = exports.getOwners = exports.getByUuid = exports.getAccounts = void 0;
var antd_1 = require("antd");
var flow_1 = __importDefault(require("lodash/flow"));
var filter_1 = __importDefault(require("lodash/fp/filter"));
var flatten_1 = __importDefault(require("lodash/fp/flatten"));
var map_1 = __importDefault(require("lodash/fp/map"));
var uniq_1 = __importDefault(require("lodash/fp/uniq"));
var pick_1 = __importDefault(require("lodash/pick"));
var effects_1 = require("redux-saga/effects");
var typesafe_actions_1 = require("typesafe-actions");
var finance_client_1 = require("@evenfinancial/finance-client");
var api_client_1 = require("@portal/api-client");
var common_1 = require("@portal/common");
var sagas_1 = require("../user/sagas");
var selectors_1 = require("../user/selectors");
var actions = __importStar(require("./actions"));
var selectors_2 = require("./selectors");
function getAccounts(action) {
    var shouldGetSubAccountOwners, accounts, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 8]);
                return [4, (0, effects_1.select)(selectors_1.selectPermissions)];
            case 1:
                shouldGetSubAccountOwners = (_a.sent()).shouldGetSubAccountOwners;
                return [4, (0, effects_1.call)([api_client_1.client, 'get'], '/finance/accounts', {
                        params: { limit: 1e5 },
                    })];
            case 2:
                accounts = (_a.sent()).data;
                if (!shouldGetSubAccountOwners) return [3, 4];
                return [4, (0, effects_1.call)(getAccountOwners, accounts, action === null || action === void 0 ? void 0 : action.payload.cookie)];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [4, (0, effects_1.put)(actions.accountRequestAction.success(accounts))];
            case 5:
                _a.sent();
                return [3, 8];
            case 6:
                err_1 = _a.sent();
                return [4, (0, effects_1.put)(actions.accountRequestAction.failure(err_1))];
            case 7:
                _a.sent();
                return [3, 8];
            case 8: return [2];
        }
    });
}
exports.getAccounts = getAccounts;
function getByUuid(action) {
    var _a, uuid, cookie, shouldGetSubAccountOwners, account, err_2, router;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, uuid = _a.uuid, cookie = _a.cookie;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 7, , 11]);
                return [4, (0, effects_1.select)(selectors_1.selectPermissions)];
            case 2:
                shouldGetSubAccountOwners = (_b.sent()).shouldGetSubAccountOwners;
                return [4, (0, effects_1.call)([api_client_1.client, 'get'], "/finance/accounts/".concat(uuid))];
            case 3:
                account = (_b.sent()).data;
                if (!shouldGetSubAccountOwners) return [3, 5];
                return [4, (0, effects_1.call)(getAccountOwners, [account], cookie)];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5: return [4, (0, effects_1.put)(actions.accountByUuidAction.success(account))];
            case 6:
                _b.sent();
                return [3, 11];
            case 7:
                err_2 = _b.sent();
                return [4, (0, effects_1.getContext)('Router')];
            case 8:
                router = _b.sent();
                return [4, (0, effects_1.call)([router, 'replace'], '/404')];
            case 9:
                _b.sent();
                return [4, (0, effects_1.put)(actions.accountByUuidAction.failure(err_2))];
            case 10:
                _b.sent();
                return [3, 11];
            case 11: return [2];
        }
    });
}
exports.getByUuid = getByUuid;
function getAccountOwners(accounts, cookie) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, getOwners(accounts, 'accountOwners', cookie)];
            case 1:
                _a.sent();
                return [2];
        }
    });
}
function getOwners(records, ownersKey, cookie) {
    var ownerKeys, usersByUuid_1, ownerUuids, _i, ownerUuids_1, uuid, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                ownerKeys = [
                    'supplyPartnerManager',
                    'supplyYieldManager',
                    'demandPartnerManager',
                    'demandYieldManager',
                ];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 7, , 8]);
                return [4, (0, effects_1.select)(selectors_1.selectUsersByUuid)];
            case 2:
                usersByUuid_1 = _a.sent();
                ownerUuids = (0, flow_1.default)([
                    (0, map_1.default)(function (record) {
                        return record[ownersKey]
                            ? Object.values((0, pick_1.default)(record[ownersKey], ownerKeys))
                            : [];
                    }),
                    flatten_1.default,
                    uniq_1.default,
                    (0, filter_1.default)(function (uuid) {
                        return Object.prototype.hasOwnProperty.call(usersByUuid_1, uuid);
                    }),
                ])(records);
                _i = 0, ownerUuids_1 = ownerUuids;
                _a.label = 3;
            case 3:
                if (!(_i < ownerUuids_1.length)) return [3, 6];
                uuid = ownerUuids_1[_i];
                return [4, (0, effects_1.call)(sagas_1.getUserByUuidRequest, { cookie: cookie, uuid: uuid })];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5:
                _i++;
                return [3, 3];
            case 6: return [3, 8];
            case 7:
                error_1 = _a.sent();
                console.error(error_1);
                return [3, 8];
            case 8: return [2];
        }
    });
}
exports.getOwners = getOwners;
function createAccount(action) {
    var formParams, accountOwners, params, billingCycle, created, router, err_3, portalError;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    return __generator(this, function (_m) {
        switch (_m.label) {
            case 0:
                _m.trys.push([0, 6, , 8]);
                formParams = action.payload;
                accountOwners = action.payload.accountOwners;
                params = {
                    accountOwners: accountOwners,
                    billingName: formParams.billingName,
                    name: formParams.name,
                };
                billingCycle = [];
                if ((_b = (_a = formParams === null || formParams === void 0 ? void 0 : formParams.payable) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.termUnit) {
                    billingCycle.push({
                        effectiveAt: (_e = (_d = (_c = formParams === null || formParams === void 0 ? void 0 : formParams.payable[0]) === null || _c === void 0 ? void 0 : _c.effectiveAt) === null || _d === void 0 ? void 0 : _d.toISOString().split('T')[0]) !== null && _e !== void 0 ? _e : '',
                        ledgerItemType: finance_client_1.LedgerItemType.Payable,
                        netD: parseInt(formParams.payable[0].netD, 10),
                        termUnit: formParams.payable[0].termUnit,
                    });
                }
                if ((_g = (_f = formParams === null || formParams === void 0 ? void 0 : formParams.receivable) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.termUnit) {
                    billingCycle.push({
                        effectiveAt: (_l = (_k = (_j = (_h = formParams === null || formParams === void 0 ? void 0 : formParams.receivable[0]) === null || _h === void 0 ? void 0 : _h.effectiveAt) === null || _j === void 0 ? void 0 : _j.toISOString()) === null || _k === void 0 ? void 0 : _k.split('T')[0]) !== null && _l !== void 0 ? _l : '',
                        ledgerItemType: finance_client_1.LedgerItemType.Receivable,
                        netD: parseInt(formParams.receivable[0].netD, 10),
                        termUnit: formParams.receivable[0].termUnit,
                    });
                }
                params.billingCycles = billingCycle;
                return [4, (0, effects_1.call)([api_client_1.client, 'post'], '/finance/accounts', params)];
            case 1:
                created = (_m.sent()).data;
                return [4, (0, effects_1.call)([antd_1.message, 'success'], 'The account was created successfully')];
            case 2:
                _m.sent();
                return [4, (0, effects_1.put)(actions.accountCreateRequestAction.success(created))];
            case 3:
                _m.sent();
                return [4, (0, effects_1.getContext)('Router')];
            case 4:
                router = _m.sent();
                return [4, (0, effects_1.call)([router, 'push'], "/accounts/".concat(created.uuid))];
            case 5:
                _m.sent();
                return [3, 8];
            case 6:
                err_3 = _m.sent();
                portalError = (0, common_1.getPortalError)(err_3);
                return [4, (0, effects_1.put)(actions.accountCreateRequestAction.failure(portalError))];
            case 7:
                _m.sent();
                return [3, 8];
            case 8: return [2];
        }
    });
}
exports.createAccount = createAccount;
function updateAccount(action) {
    var formParams, updated, err_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                formParams = action.payload;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 6, , 8]);
                return [4, (0, effects_1.call)([api_client_1.client, 'patch'], "/finance/accounts/".concat(formParams.uuid), formParams)];
            case 2:
                updated = (_a.sent()).data;
                return [4, (0, effects_1.call)([antd_1.message, 'success'], 'The account was updated successfully')];
            case 3:
                _a.sent();
                return [4, (0, effects_1.put)(actions.accountUpdateRequestAction.success(updated))];
            case 4:
                _a.sent();
                return [4, (0, effects_1.put)(actions.accountByUuidAction.request(updated))];
            case 5:
                _a.sent();
                return [3, 8];
            case 6:
                err_4 = _a.sent();
                return [4, (0, effects_1.put)(actions.accountUpdateRequestAction.failure(err_4))];
            case 7:
                _a.sent();
                return [3, 8];
            case 8: return [2];
        }
    });
}
exports.updateAccount = updateAccount;
function updateAccountPayoutSettings(action) {
    var account, formParams, updatedAccount, updated, err_5;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 6, , 8]);
                return [4, (0, effects_1.select)(selectors_2.selectFirstAccount)];
            case 1:
                account = _c.sent();
                formParams = action.payload;
                updatedAccount = __assign(__assign({}, account), { billingEmail: formParams.billingEmail, w9File: {
                        data: (_a = formParams.w9File) === null || _a === void 0 ? void 0 : _a.file.url,
                        name: (_b = formParams.w9File) === null || _b === void 0 ? void 0 : _b.file.name,
                    } });
                return [4, (0, effects_1.call)([api_client_1.client, 'patch'], "/finance/accounts/".concat(updatedAccount.uuid), updatedAccount)];
            case 2:
                updated = (_c.sent()).data;
                return [4, (0, effects_1.call)([antd_1.message, 'success'], 'You have successfully submitted your information!')];
            case 3:
                _c.sent();
                return [4, (0, effects_1.put)(actions.accountUpdatePayoutSettingsRequestAction.success(updated))];
            case 4:
                _c.sent();
                return [4, (0, effects_1.put)(actions.accountByUuidAction.request(updated))];
            case 5:
                _c.sent();
                return [3, 8];
            case 6:
                err_5 = _c.sent();
                return [4, (0, effects_1.put)(actions.accountUpdateRequestAction.failure(err_5))];
            case 7:
                _c.sent();
                return [3, 8];
            case 8: return [2];
        }
    });
}
exports.updateAccountPayoutSettings = updateAccountPayoutSettings;
function createAccountDeactivations(action) {
    var accountIds, createDeactivations, err_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                accountIds = action.payload.accountIds;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 5, , 7]);
                return [4, (0, effects_1.call)([api_client_1.client, 'post'], '/finance/deactivations/accounts', {
                        accountIds: accountIds,
                    })];
            case 2:
                createDeactivations = (_a.sent()).data;
                return [4, (0, effects_1.call)([antd_1.message, 'success'], 'The Account Status Was Successfully Updated')];
            case 3:
                _a.sent();
                return [4, (0, effects_1.put)(actions.createAccountDeactivationsAction.success(createDeactivations))];
            case 4:
                _a.sent();
                return [3, 7];
            case 5:
                err_6 = _a.sent();
                return [4, (0, effects_1.put)(actions.createAccountDeactivationsAction.failure(err_6))];
            case 6:
                _a.sent();
                return [3, 7];
            case 7: return [2];
        }
    });
}
exports.createAccountDeactivations = createAccountDeactivations;
function getDeactivationAccounts() {
    var accountsDeactivation, err_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4, (0, effects_1.call)([api_client_1.client, 'get'], '/finance/deactivations/accounts')];
            case 1:
                accountsDeactivation = (_a.sent()).data;
                return [4, (0, effects_1.put)(actions.accountDeactivationRequestAction.success(accountsDeactivation))];
            case 2:
                _a.sent();
                return [3, 5];
            case 3:
                err_7 = _a.sent();
                return [4, (0, effects_1.put)(actions.accountDeactivationRequestAction.failure(err_7))];
            case 4:
                _a.sent();
                return [3, 5];
            case 5: return [2];
        }
    });
}
exports.getDeactivationAccounts = getDeactivationAccounts;
function deleteAccountDeactivation(action) {
    var deactivationIds, deleteDeactivations, err_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                deactivationIds = action.payload.deactivationIds;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 5, , 7]);
                return [4, (0, effects_1.call)([api_client_1.client, 'put'], '/finance/deactivations/accounts', {
                        ids: deactivationIds,
                    })];
            case 2:
                deleteDeactivations = (_a.sent()).data;
                return [4, (0, effects_1.call)([antd_1.message, 'success'], 'The Account Status Was Successfully Updated')];
            case 3:
                _a.sent();
                return [4, (0, effects_1.put)(actions.deleteAccountDeactivationAction.success(deleteDeactivations))];
            case 4:
                _a.sent();
                return [3, 7];
            case 5:
                err_8 = _a.sent();
                return [4, (0, effects_1.put)(actions.deleteAccountDeactivationAction.failure(err_8))];
            case 6:
                _a.sent();
                return [3, 7];
            case 7: return [2];
        }
    });
}
exports.deleteAccountDeactivation = deleteAccountDeactivation;
function getSelfServiceAccounts() {
    var accounts, err_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4, (0, effects_1.call)([api_client_1.client, 'get'], '/analytics/self-service')];
            case 1:
                accounts = (_a.sent()).data;
                return [4, (0, effects_1.put)(actions.accountsSelfServiceRequestAction.success(accounts))];
            case 2:
                _a.sent();
                return [3, 5];
            case 3:
                err_9 = _a.sent();
                return [4, (0, effects_1.put)(actions.accountsSelfServiceRequestAction.failure(err_9))];
            case 4:
                _a.sent();
                return [3, 5];
            case 5: return [2];
        }
    });
}
exports.getSelfServiceAccounts = getSelfServiceAccounts;
function accountSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, (0, effects_1.takeEvery)((0, typesafe_actions_1.getType)(actions.accountDeactivationRequestAction.request), getDeactivationAccounts)];
            case 1:
                _a.sent();
                return [4, (0, effects_1.takeEvery)((0, typesafe_actions_1.getType)(actions.createAccountDeactivationsAction.request), createAccountDeactivations)];
            case 2:
                _a.sent();
                return [4, (0, effects_1.takeEvery)((0, typesafe_actions_1.getType)(actions.deleteAccountDeactivationAction.request), deleteAccountDeactivation)];
            case 3:
                _a.sent();
                return [4, (0, effects_1.takeEvery)((0, typesafe_actions_1.getType)(actions.accountCreateRequestAction.request), createAccount)];
            case 4:
                _a.sent();
                return [4, (0, effects_1.takeEvery)((0, typesafe_actions_1.getType)(actions.accountRequestAction.request), getAccounts)];
            case 5:
                _a.sent();
                return [4, (0, effects_1.takeEvery)((0, typesafe_actions_1.getType)(actions.accountByUuidAction.request), getByUuid)];
            case 6:
                _a.sent();
                return [4, (0, effects_1.takeEvery)((0, typesafe_actions_1.getType)(actions.accountUpdateRequestAction.request), updateAccount)];
            case 7:
                _a.sent();
                return [4, (0, effects_1.takeLatest)((0, typesafe_actions_1.getType)(actions.accountUpdatePayoutSettingsRequestAction.request), updateAccountPayoutSettings)];
            case 8:
                _a.sent();
                return [4, (0, effects_1.takeLatest)((0, typesafe_actions_1.getType)(actions.accountsSelfServiceRequestAction.request), getSelfServiceAccounts)];
            case 9:
                _a.sent();
                return [2];
        }
    });
}
exports.accountSaga = accountSaga;
